import { render, staticRenderFns } from "./AnimalNutritionRuminantsPage.vue?vue&type=template&id=c6c267de&scoped=true&"
import script from "./AnimalNutritionRuminantsPage.vue?vue&type=script&lang=js&"
export * from "./AnimalNutritionRuminantsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6c267de",
  null
  
)

export default component.exports